<template>
  <transaction-blank-form
    submit-label="Сохранить"
    v-bind="$attrs"
    form-type="edit"
    :errors="errors"
    @submit="processTransactionForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { updateTransaction } from '@/services/transaction.service'
import transactionBlankForm from '@/components/forms/transaction/TransactionBlankForm'

export default {
  name: 'transaction-edit-form',
  components: { transactionBlankForm },
  inheritAttrs: false,
  data () {
    return {
      errors: {
        transaction: {
          id: [],
          amount: [],
          transaction_type: [],
          datetime: [],
          notation: [],
          client: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processTransactionForm () {
      this.updateTransaction().then((success) => {
        if (success) {
          this.showMsg('Информация была успешно обновлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    updateTransaction () {
      return updateTransaction(this.$attrs.transaction).then((response) => {
        this.fillErrors(this.errors.transaction, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.transaction, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// TransactionEditForm.vue?add891e4